import { render, staticRenderFns } from "./ReservationListPage.vue?vue&type=template&id=6ba0d82f&"
import script from "./ReservationListPage.vue?vue&type=script&lang=js&"
export * from "./ReservationListPage.vue?vue&type=script&lang=js&"
import style0 from "./ReservationListPage.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports